<div
  class="notification-item"
  [class.unread]="!notification.isRead"
  [class.expanded]="notification.isExpanded"
  [class.tlm-item]="!!tlmKind"
>
  <!-- <div class="notification-indicator" *ngIf="isIndicatorVisible"></div> -->

  <!-- <button class="expand-btn-topleft" (click)="onToggle(); $event.stopPropagation()"
    [pTooltip]="notification.isExpanded ? 'Collapse' : 'Expand'" tooltipPosition="top">
    <i class="pi" [ngClass]="notification.isExpanded ? 'pi-angle-up' : 'pi-angle-down'"></i>
  </button> -->

  <div class="notification-content cursor-pointer" (click)="onViewDetails($event)">
    <div class="notification-header">
      <div *ngIf="receivedNotifications" class="notification-title-row">
        <div class="left-section">
          <i
            class="pi notification-icon"
            [ngClass]="notification.iconClass"
            [style.background-color]="notification.iconBackgroundColor"
            [pTooltip]="
              notification.notificationInstance?.Name || 'Notification'
            "
            tooltipPosition="top"
          ></i>
        </div>

        <div class="tlm-title-block" *ngIf="tlmKind; else plainTitle">
          <span class="tlm-tag" [class.tlm-tag--alarm]="tlmKind === 'alarm'" [class.tlm-tag--request]="tlmKind === 'request'">
            {{ tlmKind === 'alarm' ? 'ALARM' : 'REQUEST' }}
          </span>
          <span class="notification-title" [class.notification-unread]="!notification.isRead" [pTooltip]="notification.fullTitle" tooltipPosition="top">
            {{ notification.title }}
          </span>
          <span class="tlm-location" *ngIf="notification.locationName">
            <i class="pi pi-map-marker"></i> {{ notification.locationName }}
          </span>
        </div>
        <ng-template #plainTitle>
          <span
            class="notification-title"
            [class.notification-unread]="!notification.isRead"
            [pTooltip]="notification.fullTitle"
            tooltipPosition="top"
          >
            {{ notification.title }}
          </span>
        </ng-template>
      </div>

      <div *ngIf="!receivedNotifications" class="notification-title-row">
        <div class="left-section">
          <i
            class="pi notification-icon"
            [ngClass]="notification.iconClass"
            [style.background-color]="notification.iconBackgroundColor"
            [pTooltip]="
              notification.notificationInstance?.Name || 'Notification'
            "
            tooltipPosition="top"
          ></i>
        </div>
        <div class="left-section left-section-created-by">
          <span
            class="notification-title notification-title-created-by"
            [pTooltip]="notification.fullTitle"
            tooltipPosition="top"
          >
            {{ notification.title }}
          </span>
          <span
            [class.pill--powder]="
              notification.notificationInstance?.NotificationStatusId ===
              NotificationStatuses.Publishing
            "
            [class.pill--yellow]="
              notification.notificationInstance?.NotificationStatusId ===
              NotificationStatuses.Draft
            "
            [class.pill--mint]="
              notification.notificationInstance?.NotificationStatusId ===
              NotificationStatuses.Published
            "
          >
            {{
              notification.notificationInstance?.NotificationStatusDescription
            }}
          </span>
          <div *ngIf="!receivedNotifications"
          class="time-ago"
          [pTooltip]="notification.timeAgo"
          tooltipPosition="top"
          style="display: flex; align-items: center"
          >
            <i class="pi pi-clock" style="margin-right: 4px"></i>
            {{ notification.timeAgo }}
          </div>
        </div>
      </div>

      <div
        [class.header-actions]="receivedNotifications"
        [class.header-actions-created]="!receivedNotifications"
      >
        <!-- FENIKS US-10.5 — an alarm's Acknowledge sits under the time, right -->
        <div *ngIf="receivedNotifications" class="time-stack">
          <div
            class="time-ago"
            [pTooltip]="notification.timeAgo"
            tooltipPosition="top"
            style="display: flex; align-items: center"
          >
            <i class="pi pi-clock" style="margin-right: 4px"></i>
            {{ notification.timeAgo }}
          </div>
          <button
            *ngIf="tlmKind === 'alarm' && canAcknowledge"
            type="button"
            class="tlm-ack"
            [disabled]="notification.isAcknowledging"
            (click)="onAcknowledge($event)"
          >
            <i class="pi pi-check"></i> Acknowledge
          </button>
        </div>
        <!-- FENIKS US-10.5 (decision 2026-10-19): TLM items are not retired by the server — the manager discards them too -->
        <button
          *ngIf="receivedNotifications"
          class="close-btn-header cursor-pointer"
          (click)="onRemove($event)"
          pTooltip="Discard notification"
          tooltipPosition="left"
        >
          <span class="cursor-pointer" (click)="onRemove($event)">
            <i class="pi pi-times-circle cursor-pointer" (click)="onRemove($event)"></i>
          </span>
        </button>


        <!-- <button *ngIf="receivedNotifications" class="read-status-btn" [class.read]="notification.isRead"
          [class.updating]="notification.isUpdatingReadStatus" [disabled]="notification.isUpdatingReadStatus"
          [pTooltip]="notification.isRead ? 'Mark as unread' : 'Mark as read'" tooltipPosition="top"
          (click)="onToggleReadStatus($event)">
          <i *ngIf="notification.isRead" class="pi pi-check"></i>
          <span class="status-text">{{ notification.isRead ? 'Read' : 'Unread' }}</span>
        </button> -->
        <button
          *ngIf="
            !receivedNotifications &&
            notification.notificationInstance?.NotificationStatusId ===
              NotificationStatuses.Draft
          "
          class="read-status-btn"
          [class.read]="notification.isRead"
          [pTooltip]="'Publish notification'"
          tooltipPosition="top"
          [class.publish]="
            notification.notificationInstance?.NotificationStatusId ===
            NotificationStatuses.Draft
          "
          (click)="
            onUpdateNotificationStatus($event, NotificationStatuses.Publishing)
          "
        >
          <i class="pi pi-send"></i>
          <span class="status-text" style="color: #333333 !important"
            >Publish</span
          >
        </button>
        <button
          *ngIf="
            !receivedNotifications &&
            notification.notificationInstance?.NotificationStatusId ===
              NotificationStatuses.Published
          "
          class="read-status-btn"
          [class.read]="notification.isRead"
          [pTooltip]="'Set as expired'"
          tooltipPosition="top"
          [class.expire]="
            notification.notificationInstance?.NotificationStatusId ===
            NotificationStatuses.Published
          "
          (click)="
            onUpdateNotificationStatus($event, NotificationStatuses.Expired)
          "
        >
          <i class="pi pi-calendar-times"></i>
          <span class="status-text" style="color: #333333 !important"
            >Expire</span
          >
        </button>
        <button
          *ngIf="!receivedNotifications"
          class="close-btn-header cursor-pointer"
          (click)="onDelete($event)"
          pTooltip="Delete notification"
          tooltipPosition="top"
        >
          <span class="cursor-pointer" (click)="onDelete($event)">
            <i class="pi pi-times-circle cursor-pointer" (click)="onDelete($event)"></i>
          </span>
        </button>
      </div>
    </div>

    <div
      class="notification-details"
      [@slideDown]="notification.isExpanded ? 'expanded' : 'collapsed'"
    >
      <p class="notification-message">
        {{ notification.message }}
      </p>

      <div class="notification-footer">
        <div *ngFor="let field of footerFields"
        class="footer-column"
        [class.annon-created-by]="notification.isCreatedByCurrentUser  && notification.notificationType === 'announcement'">
          <ng-container
            *ngIf="
              field &&
              field.Code &&
              (field.displayValue || field.isConversation)
            "
          >
            <!-- <div class="field-label">{{ field.displayName }}</div> -->
            <div
            class="field-value">

              <button
                *ngIf="field.isLink && !field.isConversation"
                class="link-button"
                [style.font-style]="'italic'"
                [pTooltip]="field.Value"
                tooltipPosition="left"
                (click)="onOpenLink(field.Value)"
              >
                {{ trimValue(field.Value) }}
              </button>

              <div
                *ngIf="
                  !field.isLink && !field.isConversation && field.pillClass
                "
                class="pill"
                [ngClass]="'pill--' + field.pillClass"
              >
                <i
                  *ngIf="field.icon"
                  class="pi"
                  [ngClass]="field.icon"
                  [style.color]="field.color"
                ></i>
                {{ field.displayValue }}
              </div>

              <span
                *ngIf="field.Code === 'expire_on'"
              >
                <i
                  class="pi pi-clock"
                  [style.font-weight]="'bold'"
                  [style.color]="'#606060'"
                ></i>
                Expires: {{ notification.formattedExpirationDate }}
              </span>

              <span
                *ngIf="
                  !field.isLink && !field.isConversation && !field.pillClass && !(field.Code === 'expire_on')
                "
              >
                <i
                  *ngIf="field.icon"
                  class="pi"
                  [ngClass]="field.icon"
                  [style.color]="field.color"
                ></i>
                {{ field.displayValue }}
              </span>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
